import React from "react";
import { List } from "../modules/Users";

export function UsersListPage() {
  return <List />;
}
